import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import PaymentErrorDialog from "../../../components/dialogs/PaymentErrorDialog";
import { PATH } from "../../../router/path";

interface OrderFailProps {
	errorMessage: string;
	isPaymentFailure?: boolean;
}

const OrderFail: React.FC<OrderFailProps> = ({ errorMessage, isPaymentFailure = false }) => {
	const navigate = useNavigate();

	const handlePaymentErrorClose = useCallback(() => {
		if (isPaymentFailure) {
			navigate(PATH.PAYMENT, { replace: true });
		} else {
			navigate(PATH.PRODUCT_LIST, { replace: true });
		}
	}, [navigate, isPaymentFailure]);

	return (
		<div className="OrderContainer">
			<PaymentErrorDialog
				open={true}
				errorMessage={errorMessage}
				onClose={handlePaymentErrorClose}
			/>
		</div>
	);
};

export default OrderFail;
